/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: MerchantCouponsContract
 */

import { apiClient } from '../../utils/api-client';
import { toIsoString } from '@zlinkx/shared-v2';
import type {
  CreateCouponBodyType,
  CreateCouponParamsType,
  CreateCouponResponseType,
  GetCouponParamsType,
  GetCouponResponseType,
  ListCouponsParamsType,
  ListCouponsQueryType,
  ListCouponsResponseType,
  MessageResponse,
} from '@zlinkx/shared-v2';

type SerializableQueryValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

function serializeQueryValue(value: unknown): string | number | boolean | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (value instanceof Date) {
    return toIsoString(value);
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  return String(value);
}

function serializeQueryParams(params?: Record<string, unknown>): Record<string, SerializableQueryValue> | undefined {
  if (!params) {
    return undefined;
  }

  const serialized: Record<string, SerializableQueryValue> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const arrayValues = value
        .map(item => serializeQueryValue(item))
        .filter((item): item is string | number | boolean => item !== undefined);

      if (arrayValues.length > 0) {
        serialized[key] = arrayValues;
      }
      return;
    }

    const scalarValue = serializeQueryValue(value);
    if (scalarValue !== undefined) {
      serialized[key] = scalarValue;
    }
  });

  return Object.keys(serialized).length > 0 ? serialized : undefined;
}

export const merchantcouponsApi = {
  listCoupons: async (
    merchantId: ListCouponsParamsType['merchantId'],
    params?: ListCouponsQueryType
  ): Promise<ListCouponsResponseType> => {
    return apiClient.get<ListCouponsResponseType['data']>(`/merchants/${merchantId}/coupons`, { params: serializeQueryParams(params) }) as Promise<ListCouponsResponseType>;
  },

  getCoupon: async (
    merchantId: GetCouponParamsType['merchantId'],
    couponId: GetCouponParamsType['couponId']
  ): Promise<GetCouponResponseType> => {
    return apiClient.get<GetCouponResponseType['data']>(`/merchants/${merchantId}/coupons/${couponId}`) as Promise<GetCouponResponseType>;
  },

  createCoupon: async (
    merchantId: CreateCouponParamsType['merchantId'],
    data: CreateCouponBodyType
  ): Promise<CreateCouponResponseType> => {
    return apiClient.post<CreateCouponResponseType['data']>(`/merchants/${merchantId}/coupons`, data) as Promise<CreateCouponResponseType>;
  },
};